<template>
  <GridViewPlantsWithDates>
    <CardItemPlantaAbateCarregamento />
    <DialogConfirmarAlteracoes
      :dialog="dialogConfirmarCarregamento"
      @cancelarConfirmacao="closeDialogConfirmar"
      @sendConfirmarCarregamento="sendConfirmarCarregamento"
      window="carregamento"
      :heightTotal="240"
    />
  </GridViewPlantsWithDates>
</template>

<script>
import { mapActions, mapState } from "vuex";

import GridViewPlantsWithDates from "../components/GridViewPlantsWithDates.vue";
import CardItemPlantaAbateCarregamento from "../components/CardItemPlantaAbateCarregamento.vue";
import DialogConfirmarAlteracoes from "../components/DialogConfirmarAlteracoes.vue";

export default {
  name: "Carregamento",
  components: {
    GridViewPlantsWithDates,
    CardItemPlantaAbateCarregamento,
    DialogConfirmarAlteracoes,
  },
  props: {
    confirmarCarregamento: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogConfirmarCarregamento: false,
    };
  },
  computed: {
    ...mapState("programacaoAbate", ["listCheckListAlocados"])
  },
  methods: {
    ...mapActions("programacaoAbate", ["ActionConfirmarLotes"]),
    openConfirmarCarregamento(value) {
      this.dialogConfirmarCarregamento = value;
    },
    closeDialogConfirmar() {
      this.dialogConfirmarCarregamento = false;
      this.$emit("cancelConfirmarCarregamento");
    },
    sendConfirmarCarregamento() {
      let validCounter = 0
      this.listCheckListAlocados.forEach((item) => {
        if (item.stCarregamentoPeriodo) validCounter++
      })
      
      if (validCounter > 0 && this.listCheckListAlocados.length === validCounter) {
        this.ActionConfirmarLotes(5);
      }
      
      this.closeDialogConfirmar();
    },
    canConfirmWithRaise() {
      let notValidCounter = 0
      this.listCheckListAlocados.forEach((item) => {
        if (!item.stCarregamentoPeriodo) notValidCounter++
      })
      
      if (notValidCounter > 0 && this.listCheckListAlocados.length !== notValidCounter) {
        return true
      }
      
      // if (this.listCheckListAlocados.length === notValidCounter) {
      //   this.$store.commit("setSnack", {
      //     type: "error",
      //     msg: "Todos os lotes estão sem período informado"
      //   })
      //   return false
      // }
      
      return true
    },
  },
  watch: {
    confirmarCarregamento(newValue, oldValue) {
        if (!this.canConfirmWithRaise()) {
        this.$emit("update:confirmarCarregamento", false)
      } else {
        this.openConfirmarCarregamento(newValue);
      }
    },
  },
};
</script>

<style lang="scss">
</style>
